import { PRIV_MANAGE, TASK_ACTIVE, TASK_ARCHIVED, TASK_OVERDUE, TASK_PROG_APPROVED, TASK_PROG_CANCELLED, TASK_PROG_COMPLETE, TASK_PROG_IN_PROGRESS, TASK_PROG_NOT_STARTED, TASK_PROG_REJECTED, TASK_SCHEDULED, TASK_SYSTEM_NORMAL, TASK_SYSTEM_REVIEW } from './constants';
import { printThis, taskForm } from './main';
import { ajaxPromise, checkChosenChanged, confirmDialog, displayNotification, getDateFilter, htmlEsc, initDateFilter, logerror, post, toggleSlide } from './utils';

const clearReassignModal = () => {
	$('#task_reassign_user_group').show();
	$('#task_reassign_ext_recip_group').hide();
	$('#task_reassign_email_group').hide();
	$('#task_reassign_user,#task_reassign_email,#task_reassign_notes,#task_reassign_duedate,#task_reassign_notify').val('');
	$('#task_reassign_user,#task_reassign_notify').trigger('chosen:updated');
	$('#task_reassign_ext_recip').val('').trigger('chosen:updated');
	$('#task_reassign_external').bootstrapToggle('off');
	$('#task_reassign_notify_cancelled').prop('checked', false);
};

const syncReassignExternalUi = (isExternal: boolean, showExternalRecipients: boolean) => {
	if (isExternal) {
		$('#task_reassign_user_group').hide();
		if (showExternalRecipients) $('#task_reassign_ext_recip_group').show();
		$('#task_reassign_email_group').show();
	} else {
		$('#task_reassign_user_group').show();
		$('#task_reassign_ext_recip_group').hide();
		$('#task_reassign_email_group').hide();
	}
};

export const clearTaskEditForm = () => {
	$('#task_edit_close').off('click').trigger('reset');
	$('#task_view_vendor').text('');
	$('#task_view_sender').text('');
	$('#task_view_recipients').text('');
	$('#task_view_tasks').html('');
	$('#task_view_senddate').text('');
	$('#task_view_duedate').text('').prop('min', '1000-01-01');
	$('#task_view_notify').text('');
	$('#task_view_status').text('');
	$('#task_view_notes').text('');

	$('#task_edit_col').hide();
	$('#task_edit_form').off('submit');

	$('#task_edit_submit').hide();
	$('#task_edit_reassign').off('click').hide();
	$('#task_edit_extend_due').off('click').hide();
	$('#task_edit_cancel').off('click').hide();
	$('#task_edit_expire').off('click').hide();
	$('#task_edit_archive').off('click').hide();
	$('#task_edit_reinstate').off('click').hide();
	$('#task_edit_mark_in_prog').off('click').hide();
	$('#task_edit_mark_complete').off('click').hide();
	$('#task_reassign_form').off('submit');
	$('#task_extend_due_form').off('submit');
	$('#task_reassign_user_relowners,#task_reassign_user_admins,#task_reassign_user_managers').empty();
	$('#task_reassign_ext_recip_contacts').off('change').empty();

	clearReassignModal();
};

export const loadTaskEdit = async ({ tk_guid, onUpdate = () => { }, mode = 'windowed' }) => {
	const server = await ajaxPromise('/data/task_view', { guid: tk_guid });
	const priv = server.priv;
	const currentDate = new Date().toISOString().split('T')[0];
	const task = server.task;
	const isActionItem = ![TASK_SYSTEM_NORMAL, TASK_SYSTEM_REVIEW].includes(+task.tk_ttypeid);
	const isRequestTask = task.tk_ttypeid == TASK_SYSTEM_NORMAL;
	const isReview = task.tk_ttypeid == TASK_SYSTEM_REVIEW;
	const isOpenTask = [TASK_ACTIVE, TASK_OVERDUE, TASK_SCHEDULED].includes(+task.tk_status);
	const isScheduled = task.tk_status == TASK_SCHEDULED;
	let progress = +task.tk_prog;
	const notes = server.notes;
	const excludedRecipientEmails = isRequestTask
		? new Set((task.recipient_emails || '').split(',').map((email) => email.trim().toLowerCase()).filter(Boolean))
		: new Set<string>();
	const excludedRecipientGuids = isRequestTask
		? new Set((task.recipient_guids || '').split(',').map((guid) => guid.trim()).filter(Boolean))
		: new Set<string>();

	$('#task_view_type').text(task.task_type);
	$('#task_view_priority').text(task.prior_name);
	$('#task_view_recurring').text(task.tk_recurring_pretty);
	$('#task_view_vendor').text(task.vend_name);
	$('#task_view_sender').text(task.sender);
	$('#task_view_recipients').text(task.recipients);
	$('#task_view_senddate').text(task.tk_senddate_pretty);
	$('#task_view_duedate').text(task.tk_duedate_pretty);
	$('#task_view_notify').text(task.tk_notify_pretty);
	$('#task_view_status').text(task.tk_status_pretty);

	if (task.tk_completedate_pretty && task.tk_completedate_pretty !== 'N/A') {
		$('#task_view_completedate').text(task.tk_completedate_pretty).parent().show();
	} else {
		$('#task_view_completedate').parent().hide();
	}

	if (task.tk_expireddate_pretty && task.tk_expireddate_pretty !== 'N/A') {
		$('#task_view_expiredate').text(task.tk_expireddate_pretty).parent().show();
	} else {
		$('#task_view_expiredate').parent().hide();
	}

	if (task.tk_cancelleddate_pretty && task.tk_cancelleddate_pretty !== 'N/A') {
		$('#task_view_cancelledate').text(task.tk_cancelleddate_pretty).parent().show();
	} else {
		$('#task_view_cancelledate').parent().hide();
	}

	$('#task_view_details').text(task.tk_notes);
	$('#task_view_tasks').text(server.details);

	if (isRequestTask) {
		$('#task_view_tasks').parent().show();
	} else {
		$('#task_view_tasks').parent().hide();
	}

	if (task.vend_name) {
		$('#task_view_vendor').parent().show();
	} else {
		$('#task_view_vendor').parent().hide();
	}

	$('#task_view_reviewer').parent().hide();
	$('#task_view_approved').parent().hide();
	if (isReview) {
		$('#task_view_priority').parent().hide();
		$('#task_view_recurring').parent().hide();
		$('#task_view_duedate').parent().hide();
		$('#task_view_details').text(task.tk_review_msg);
		$('#task_view_assess_type').text(task.assess_type).parent().show();
		if (task.reviewer) $('#task_view_reviewer').text(task.reviewer).parent().show();
		if (task.tk_approve) $('#task_view_approved').text(+task.tk_approve ? 'Yes' : 'No').parent().show();
		$('#task_edit_notes_col').hide();
	} else {
		$('#task_view_priority').parent().show();
		$('#task_view_recurring').parent().show();
		$('#task_view_duedate').parent().show();
		$('#task_view_assess_type').parent().hide();
		$('#task_edit_notes_col').show();
	}

	const notesUpdated = () => {
		$('#task_edit_notes_cont').empty();
		notes.forEach((note) => {
			let $note: $;
			if (note.is_self) {
				$note = $(
					<div className="well well-dark well-dark-force" style="margin-bottom: 5px; padding: 10px;">
						<div>
							<i>{note.usr_name}</i>
							{isOpenTask ? (
								<span style="float: right;">
									{note.toggled ? (
										<button className="edit btn btn-success btn-xs">
											<i className="edit fa fa-check me-2"></i>
											Save
										</button>
									) : (
										<button className="edit btn btn-primary btn-xs">
											<i className="edit fa fa-edit me-2"></i>
											Edit
										</button>
									)}
									<button className="delete btn btn-danger btn-xs ms-2">
										<i className="fa fa-trash me-2"></i>
										Delete
									</button>
								</span>
							) : ''}
						</div>
						<div>
							{!!note.toggled
								? (<textarea className="form-control">{note.note_val}</textarea>)
								: (<div>{note.note_val}</div>)
							}
						</div>
					</div>
				);
				$note.find('.edit').on('click', async () => {
					note.toggled = !note.toggled;
					notesUpdated();

					if (!note.toggled) {
						try {
							const postData = {
								type: 'task_note_update',
								json: true,
								data: JSON.stringify({
									tk_guid: task.tk_guid,
									note_guid: note.note_guid,
									note_val: $note.find('textarea').val(),
								}),
							};
							const res = await ajaxPromise('/form/submit', postData);
							if (res.rc !== 'OK') throw res;
							displayNotification('Task Update', 'Note updated.', 'success');
							note.note_guid = res.note_guid;
						}
						catch (error) {
							displayNotification('Task Update', 'An error occurred while updating the task.', 'danger');
							logerror('task_note_update', error);
						}
					}
				});

				$note.find('.delete').on('click', async () => {
					const confirmed = await confirmDialog({
						dialogTitle: 'Delete Note',
						bodyText: 'Are you sure you would like to delete this note?',
						confirmText: 'Delete',
						confirmStyle: 'danger',
					});
					if (!confirmed) return;

					notes.splice(notes.indexOf(note), 1);
					notesUpdated();

					if (!note.note_guid) return;

					try {
						const postData = {
							type: 'task_note_delete',
							json: true,
							data: JSON.stringify({
								tk_guid: task.tk_guid,
								note_guid: note.note_guid,
							}),
						};
						const res = await ajaxPromise('/form/submit', postData);
						if (res.rc !== 'OK') throw res;

						displayNotification('Task Update', 'Note deleted.', 'success');
						note.note_guid = res.note_guid;
					}
					catch (error) {
						displayNotification('Task Update', 'An error occurred while updating the task.', 'danger');
						logerror('task_note_delete', error);
					}
				});

				$note.find('textarea').on('change', () => {
					note.note_val = $note.find('textarea').val();
				});
			} else {
				$note = (
					<div className="well well-dark" style="margin-bottom: 5px; padding: 10px;">
						<div><i>{note.usr_name}</i></div>
						<div>{note.note_val}</div>
					</div>
				);
			}
			$('#task_edit_notes_cont').append($note);
		});
	};

	$('#task_edit_notes_add').off('click').on('click', () => {
		notes.push({
			note_guid: null,
			note_val: '',
			usr_name: 'You, just now',
			is_self: true,
			toggled: true,
		});
		notesUpdated();
	});

	$('#task_edit_notes_add').prop('disabled', !isOpenTask);

	notesUpdated();

	const saveProg = async (prog) => {
		try {
			const postData = {
				type: 'task_mark_prog',
				json: true,
				data: JSON.stringify({
					tk_guid: task.tk_guid,
					tk_prog: prog,
				}),
			};
			const res = await ajaxPromise('/form/submit', postData);
			if (res.rc !== 'OK') throw res;
			displayNotification('Task Update', 'Task updated.', 'success');
			progress = prog;
			progChanged();
		}
		catch (error) {
			displayNotification('Task Update', 'An error occurred while updating the task.', 'danger');
			logerror('task_update', error);
		}
	};

	// print handler for task edit
	$('#task_edit_print').off('click').on('click', function () {
		let title = $('#task_reassign_duedate').val() + ' - Task';
		let config = {
			title: title,
			callback: () => {
				const $target = $('#task_edit_container');
				let $body = $target.clone();
				$body.find('#task_edit_controls').remove();
				$body.find('#task_view_status_history').remove();
				$body.find('#task_edit_notes_add').remove();
				$body.find('#task_add_attachments_add').remove();
				$body.find('input').each((_, element) => {
					$(element).attr('value', $(element).val().toString());
				});
				$body.find('#task_add_attachments').find('.edit, .delete').remove();
				$target.find('select').each((_, element) => {
					const $t = $body.find('#' + $(element).attr('id'));
					$t.val($(element).val());
					$t.find('option:selected').attr('selected', 'selected');
				});
				$body.find('textarea').each((_, element) => {
					$(element).html($(element).val().toString());
				});
				return $body;
			},
		};
		printThis(config);
		ajaxPromise('/form/submit', { type: 'task_edit_print', data: { guid: task.tk_guid } }).catch((error) => {
			logerror('task edit print', error);
		});

		return false;
	});

	$('#task_edit_mark_in_prog').off('click').on('click', async () => {
		await saveProg(TASK_PROG_IN_PROGRESS);
	});
	$('#task_edit_mark_complete').off('click').on('click', async () => {
		await saveProg(TASK_PROG_COMPLETE);
	});

	const progChanged = () => {
		$('#task_view_progress').text({
			[TASK_PROG_NOT_STARTED]: 'Not Started',
			[TASK_PROG_IN_PROGRESS]: 'In Progress',
			[TASK_PROG_COMPLETE]: 'Complete',
			[TASK_PROG_CANCELLED]: 'Cancelled',
			[TASK_PROG_APPROVED]: 'Approved',
			[TASK_PROG_REJECTED]: 'Rejected',
		}[progress] ?? 'Unknown');
		$('#task_edit_mark_in_prog,#task_edit_mark_complete').hide();
		if (!isScheduled && isActionItem && isOpenTask && progress == TASK_PROG_NOT_STARTED) $('#task_edit_mark_in_prog').show();
		if (!isScheduled && isActionItem && isOpenTask && progress != TASK_PROG_COMPLETE) $('#task_edit_mark_complete').show();
	};

	progChanged();

	let showExternalRecipients = false;
	if (isRequestTask) {
		$('#task_edit_reassign').prop('disabled', true);

		const filterReassignUsers = (users: { usr_guid: string }[] = []) =>
			users.filter((user) => !excludedRecipientGuids.has(user.usr_guid));

		try {
			const res = await ajaxPromise('/data/task_view', { guid: task.tk_guid });
			if (res.rc !== 'OK') throw res;

			$('#task_view_tasks').html(res.desc);

			const recips = res.recips;
			const filteredContacts = (recips.contacts || []).filter(
				(cont) => !excludedRecipientEmails.has(cont.vcontact_email.trim().toLowerCase())
			);
			showExternalRecipients = filteredContacts.length > 0;

			const fillOptgroupWithUserOptions = ($optgroup: $, users) => {
				$optgroup.empty();
				users.forEach((user) => {
					$optgroup.append(
						<option value={user.usr_guid}>{user.usr_firstname} {user.usr_lastname}</option>
					);
				});
				$('#task_reassign_user').trigger('chosen:updated');
			};

			if (recips.relowners && recips.relowners.length) {
				fillOptgroupWithUserOptions($('#task_reassign_user_relowners'), filterReassignUsers(recips.relowners));
			}
			if (recips.admins && recips.admins.length) {
				fillOptgroupWithUserOptions($('#task_reassign_user_admins'), filterReassignUsers(recips.admins));
			}
			if (recips.managers && recips.managers.length) {
				fillOptgroupWithUserOptions($('#task_reassign_user_managers'), filterReassignUsers(recips.managers));
			}
			$('#task_reassign_user').trigger('chosen:updated');

			if (filteredContacts.length) {
				$('#task_reassign_ext_recip_contacts').empty();
				filteredContacts.forEach((cont) => {
					$('#task_reassign_ext_recip_contacts').append(
						<option value={cont.vcontact_email}>{cont.vcontact_name}</option>
					);
				});
				$('#task_reassign_ext_recip').trigger('chosen:updated');
			}

			$('#task_edit_reassign').prop('disabled', false);
		} catch (error) {
			displayNotification('Task View', 'Could not view task details.', 'danger');
			return;
		}
	}

	if (priv == PRIV_MANAGE && isOpenTask) {
		if (isActionItem) {
			$('#task_edit_add').show();
			$('#task_edit_submit').show();
		}
		else {
			$('#task_edit_submit').hide();
			$('#task_edit_add').hide();
		}

		$('#task_edit_cancel').show().on('click', (event) => {
			event.preventDefault();

			const cancel = async (options: { update_repeating?: number; notify_cancelled?: number } = { update_repeating: 0 }) => {
				try {
					const postData = {
						type: 'task_cancel',
						data: { guid: task.tk_guid, ...options },
					};
					const res = await ajaxPromise('/form/submit', postData);
					if (res.rc !== 'OK') throw res;

					displayNotification('Task Cancel', 'The task has been cancelled.', 'success');
					if (mode === 'main') window.location.reload();
					onUpdate();
					return true;
				} catch (event) {
					displayNotification('Task Cancel', 'There was an error while cancelling this task.', 'danger');
					logerror('task cancel', event);
					return false;
				}
			};

			$('#task_save_msg').text('Are you sure you would like to cancel this task?');
			$('#task_save_update_repeating_text').text(' Cancel future scheduled tasks');
			$('#task_save_update_repeating').prop('checked', false);
			$('#task_save_notify_cancelled').prop('checked', true);
			$('#task_save_notify_cancelled_cont').show();
			const showUpdateRepeating = task && +task.tk_recurring && (+task.tk_latest || task.tk_status == TASK_SCHEDULED);
			if (showUpdateRepeating) $('#task_save_update_repeating_cont').show();
			else $('#task_save_update_repeating_cont').hide();
			$('#task_save_confirm').text('Confirm').off('click').on('click', async () => {
				$('#task_save_confirm').prop('disabled', true);
				const update_repeating = showUpdateRepeating ? ($('#task_save_update_repeating').is(':checked') ? 1 : 0) : 0;
				const notify_cancelled = $('#task_save_notify_cancelled').is(':checked') ? 1 : 0;
				const success = await cancel({ update_repeating, notify_cancelled });
				$('#task_save_confirm').prop('disabled', false);
				if (success) $('#task_save_modal').modal('hide');
			});

			$('#task_save_modal').modal('show');
		});

		if (!isReview) {
			$('#task_edit_expire').show().on('click', (event) => {
				event.preventDefault();

				const expire = async (options = { update_repeating: 0 }) => {
					try {
						const postData = {
							type: 'task_expire',
							data: { guid: task.tk_guid, ...options },
						};
						const res = await ajaxPromise('/form/submit', postData);
						if (res.rc !== 'OK') throw res;

						displayNotification('Task Expire', 'The task has been set to expired.', 'success');
						if (mode === 'main') window.location.reload();
						onUpdate();
						return true;
					} catch (event) {
						displayNotification('Task Expire', 'There was an error while setting the task as expired.', 'danger');
						logerror('task expire', event);
						return false;
					}
				};

				$('#task_save_msg').text('Are you sure you would like to set this task as expired?');
				$('#task_save_update_repeating_text').text(' Expire future scheduled tasks');
				$('#task_save_update_repeating').prop('checked', false);
				$('#task_save_notify_cancelled_cont').hide();
				const showUpdateRepeating = task && +task.tk_recurring && (+task.tk_latest || task.tk_status == TASK_SCHEDULED);
				if (showUpdateRepeating) $('#task_save_update_repeating_cont').show();
				else $('#task_save_update_repeating_cont').hide();
				$('#task_save_confirm').text('Expire').off('click').on('click', async () => {
					$('#task_save_confirm').prop('disabled', true);
					const update_repeating = showUpdateRepeating ? ($('#task_save_update_repeating').is(':checked') ? 1 : 0) : 0;
					const success = await expire({ update_repeating });
					$('#task_save_confirm').prop('disabled', false);
					if (success) $('#task_save_modal').modal('hide');
				});

				$('#task_save_modal').modal('show');
			});
		}

		if (isRequestTask) {
			$('#task_reassign_external')
				.off('change')
				.on('change', (event) => {
					syncReassignExternalUi($(event.target).prop('checked'), showExternalRecipients);
				});

			$('#task_edit_reassign').show().on('click', (event) => {
				event.preventDefault();
				$('#task_reassign_duedate').val(task.tk_duedate < currentDate ? currentDate : task.tk_duedate);
				$('#task_reassign_notes').val(task.tk_notes);
				$('#task_reassign_notify').val(task.tk_notify).trigger('chosen:updated');
				$('#task_reassign_external').bootstrapToggle(+task.tk_external ? 'on' : 'off');
				syncReassignExternalUi(!!+task.tk_external, showExternalRecipients);
				$('#task_reassign_notify_cancelled').prop('checked', false);
				$('#task_reassign_modal').modal('show');
			});

			$('#task_reassign_ext_recip').off('change').on('change', ({ target }) => {
				const isCustom = !$(target).val();
				if (isCustom) $('#task_reassign_email_group').show();
				else $('#task_reassign_email_group').hide();
			});

			$('#task_reassign_form').on('submit', async (event) => {
				event.preventDefault();
				const isExternal = $('#task_reassign_external').is(':checked');
				const postData = {
					guid: task.tk_guid,
					external: isExternal ? 1 : 0,
					usr_guids: $('#task_reassign_user').val() as string[],
					email: $('#task_reassign_ext_recip').val() || $('#task_reassign_email').val(),
					duedate: $('#task_reassign_duedate').val(),
					notes: $('#task_reassign_notes').val(),
					notify: $('#task_reassign_notify').val(),
					notify_cancelled: $('#task_reassign_notify_cancelled').is(':checked') ? 1 : 0,
				};
				let bad = false;
				if (!isExternal && (!postData.usr_guids || !postData.usr_guids.length)) {
					displayNotification('Task Reassign', 'Please specify a recipient.', 'danger');
					bad = true;
				}
				if (!isExternal && postData.usr_guids?.some((guid) => excludedRecipientGuids.has(guid))) {
					displayNotification('Task Reassign', 'The new recipient must be different from the current recipient(s).', 'danger');
					bad = true;
				}
				if (isExternal && !postData.email) {
					displayNotification('Task Reassign', 'Please specify an external email address.', 'danger');
					bad = true;
				}
				if (isExternal && postData.email && excludedRecipientEmails.has(String(postData.email).trim().toLowerCase())) {
					displayNotification('Task Reassign', 'The new recipient must be different from the current recipient(s).', 'danger');
					bad = true;
				}
				if (!postData.duedate) {
					displayNotification('Task Reassign', 'Please specify a due date.', 'danger');
					bad = true;
				}
				if (postData.duedate && postData.duedate < currentDate) {
					displayNotification('Task Reassign', 'You cannot create a task in the past.', 'danger');
					bad = true;
				}
				if (bad) return;

				$('#task_reassign_submit').prop('disabled', true);
				try {
					const res = await ajaxPromise('/form/submit', { type: 'task_reassign', data: postData });
					if (res.rc !== 'OK') throw res;

					displayNotification('Task Reassign', 'The task has been reassigned.', 'success');
					onUpdate();
					$('#task_reassign_modal').modal('hide');
				}
				catch (error) {
					switch (error.rc) {
						case 'INVALID_EXTERNAL_EMAIL':
							displayNotification('Task Reassign', 'Please enter a valid external email address.  Multiple external email addresses are not allowed.', 'danger');
							break;
						case 'SAME_RECIPIENT':
							displayNotification('Task Reassign', 'The new recipient must be different from the current recipient(s).', 'danger');
							break;
						default:
							displayNotification('Task Reassign', 'Could not reassign the task.', 'danger');
							logerror('task reassign', error);
					}
				}

				$('#task_reassign_submit').prop('disabled', false);
			});
		}

		$('#task_edit_status').show().on('click', (event) => {
			event.preventDefault();
			$('#task_status_modal').modal('show');
		});

		if (isRequestTask && !isScheduled && task.tk_duedate) {
			const suggestExtendedDueDate = (currentDue: string) => {
				const due = new Date(`${currentDue}T00:00:00`);
				const today = new Date(`${currentDate}T00:00:00`);
				const base = due > today ? due : today;
				base.setDate(base.getDate() + 7);
				return base.toISOString().split('T')[0];
			};

			$('#task_edit_extend_due').show().on('click', (event) => {
				event.preventDefault();
				$('#task_extend_due_date').val(suggestExtendedDueDate(task.tk_duedate));
				$('#task_extend_due_notify').prop('checked', true);
				$('#task_extend_due_modal').modal('show');
			});

			$('#task_extend_due_form').on('submit', async (event) => {
				event.preventDefault();
				const duedate = $('#task_extend_due_date').val() as string;
				if (!duedate) {
					displayNotification('Extend Due Date', 'Please specify a due date.', 'danger');
					return;
				}
				if (duedate < currentDate) {
					displayNotification('Extend Due Date', 'You cannot set a due date in the past.', 'danger');
					return;
				}
				if (duedate <= task.tk_duedate) {
					displayNotification('Extend Due Date', 'The new due date must be later than the current due date.', 'danger');
					return;
				}

				$('#task_extend_due_submit').prop('disabled', true);
				try {
					const res = await ajaxPromise('/form/submit', {
						type: 'task_extend_due',
						data: {
							guid: task.tk_guid,
							duedate,
							notify_updated: $('#task_extend_due_notify').is(':checked') ? 1 : 0,
						},
					});
					if (res.rc !== 'OK') throw res;

					displayNotification('Extend Due Date', 'The due date has been updated.', 'success');
					onUpdate();
					$('#task_extend_due_modal').modal('hide');
				} catch (error) {
					switch (error.rc) {
						case 'NOT_EXTENDED':
							displayNotification('Extend Due Date', 'The new due date must be later than the current due date.', 'danger');
							break;
						case 'INVALID_DUEDATE':
							displayNotification('Extend Due Date', 'You cannot set a due date in the past.', 'danger');
							break;
						default:
							displayNotification('Extend Due Date', 'Could not update the due date.', 'danger');
							logerror('task extend due', error);
					}
				}

				$('#task_extend_due_submit').prop('disabled', false);
			});
		}

		taskForm({ $cont: $('#task_edit_add'), $submit: $('#task_edit_submit'), recipientView: mode === 'main', task, onCreate: () => onUpdate() });
	} else {
		$('#task_edit_add').hide();
		$('#task_edit_submit').hide();

		if (task.tk_status == TASK_ARCHIVED) {
			$('#task_edit_reinstate').show().on('click', async (event) => {
				event.preventDefault();

				try {
					const postData = {
						type: 'task_reinstate',
						data: { guid: task.tk_guid },
					};
					const res = await ajaxPromise('/form/submit', postData);
					if (res.rc !== 'OK') throw res;

					displayNotification('Task Reinstate', 'The task has been reinstated.', 'success');
					if (mode === 'main') window.location.reload();
					onUpdate();
				} catch (event) {
					displayNotification('Task Reinstate', 'There was an error while reinstating the task.', 'danger');
					logerror('task reinstate', event);
				}
			});
		} else {
			$('#task_edit_archive').show().on('click', async (event) => {
				event.preventDefault();

				try {
					const postData = {
						type: 'task_archive',
						data: { guid: task.tk_guid },
					};
					const res = await ajaxPromise('/form/submit', postData);
					if (res.rc !== 'OK') throw res;

					displayNotification('Task Archive', 'The task has been archived.', 'success');
					if (mode === 'main') window.location.reload();
					onUpdate();
				} catch (event) {
					displayNotification('Task Archive', 'There was an error while archiving the task.', 'danger');
					logerror('task archive', event);
				}
			});
		}
	}

	let statusHistoryTable = null;
	$('#task_status_filters_container .chosen').chosen({ width: '100%' });

	toggleSlide($('#task_status_filters_toggle'), $('#task_status_filters_container'));
	initDateFilter('#task_status_filters_date');

	let filtersChangeHandler = true;
	$('#task_status_filters_container').on('change', () => {
		if (!filtersChangeHandler) return;
		checkFiltersChosenChanged();
		statusHistoryTable.ajax.reload();
	});

	$('#task_status_filters_reset')
		.off('click')
		.on('click', () => {
			filtersChangeHandler = false;
			$('#task_status_filters_container').trigger('reset');
			$('#task_status_filters_container .chosen').trigger('change').trigger('chosen:updated');
			checkFiltersChosenChanged();
			statusHistoryTable.ajax.reload(null, false);
			filtersChangeHandler = true;
		});

	const checkFiltersChosenChanged = () => $('#task_status_filters_container select.chosen').each((_, element) => checkChosenChanged($(element)));

	const initStatusHistorytable = () => {
		const dbColumns: DataTables.ColumnSettings[] = [
			{ title: 'Date', data: 'audit_datetime_nice' },
			{ title: 'User', data: 'audit_username' },
			{ title: 'Action', data: 'audit_action' },
			{ title: 'Status', data: 'status_display', orderable: false, searchable: false },
			{ title: 'Progress', data: 'progress_display', orderable: false, searchable: false }
		];

		const getFilters = () => ({
			user: $('#task_status_filters_user').val(),
			action: $('#task_status_filters_action').val(),
			date: getDateFilter('#task_status_filters_date'),
		});
		const dtOptions: DataTables.Settings = {
			ajax: {
				url: '/data/tasks_status_history_load',
				data: (postData) => ({
					...postData,
					filters: getFilters(),
					tk_guid: task.tk_guid,
				}),
			},
			buttons: [
				{
					text: '<i class="fa fa-file-csv me-2"></i> Export',
					className: 'ml-2 btn btn-sm btn-secondary',
					action: ({ target }) => {
						const $btn = $(target);
						const filters = getFilters();
						$btn.prop('disabled', true);

						post('/export', {
							type: 'task_status',
							data: JSON.stringify({
								tk_guid: task.tk_guid,
								...filters,
							}),
						});

						setTimeout(() => $btn.prop('disabled', false), 1000);
					},
				},
				{
					text: '<i class="fa fa-print me-2"></i> Print',
					className: 'ml-2 btn btn-sm btn-secondary',
					action: ({ target }) => {
						const $btn = $(target);
						const filters = getFilters();
						$btn.prop('disabled', true);

						post('/printout/task_status', {
							params: JSON.stringify({
								...statusHistoryTable.ajax.params(),
								tk_guid: task.tk_guid,
								...filters,
							})
						}, '_blank');

						setTimeout(() => $btn.prop('disabled', false), 1000);
					},
				},
			],
			columns: dbColumns,
			columnDefs: [
				{ targets: [0, 1, 2], render: (val) => htmlEsc(val) },
				{ targets: [3, 4], render: (val) => val || '' },
			],
			order: [[0, 'desc']],
		};
		const taskStatusDt = $('#task_status_table').DataTable(dtOptions);

		return taskStatusDt;
	};

	// Initialize status modal DataTable when modal opens
	$('#task_status_modal').on('shown.bs.modal', function () {
		if ($('#task_status_table').hasClass('dataTable')) {
			($('#task_status_table') as any).DataTable().destroy();
		}
		statusHistoryTable = initStatusHistorytable();
	});

	// Clean up DataTable when modal closes
	$('#task_status_modal').on('hidden.bs.modal', function () {
		if ($('#task_status_table').hasClass('dataTable')) {
			($('#task_status_table') as any).DataTable().destroy();
			$('#task_status_table').empty(); // Clear the table content
		}
	});
};

$('#task_reassign_modal').on('hidden.bs.modal', () => clearReassignModal());

$('#task_extend_due_modal').on('hidden.bs.modal', () => {
	$('#task_extend_due_date').val('');
	$('#task_extend_due_notify').prop('checked', true);
});

$('#task_reassign_user,#task_reassign_notify,#task_reassign_ext_recip').chosen({ width: '100%' });

if ($('#task_edit_cont').data('guid')) {
	loadTaskEdit({ tk_guid: $('#task_edit_cont').data('guid'), mode: 'main' });
}